import { render } from "./ReviewerMainContent.vue?vue&type=template&id=40ba49d0"
import script from "./ReviewerMainContent.vue?vue&type=script&lang=js"
export * from "./ReviewerMainContent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__